/**
 * FullCalendar (@fullcalendar/core) injects bundled CSS via CSSStyleSheet.insertRule, splitting on `}`.
 * Chrome often throws DOMException / SyntaxError on @font-face rules with long data: font URLs (fcicons).
 * Patch insertRule before any module that pulls FullCalendar loads (e.g. first import in application.js).
 */
if (typeof window !== "undefined") {
  if (typeof CSSStyleSheet !== "undefined" && CSSStyleSheet.prototype) {
    const originalInsertRule = CSSStyleSheet.prototype.insertRule
    if (!originalInsertRule.__healmePatched) {
      CSSStyleSheet.prototype.insertRule = function patchedInsertRule(rule, index) {
        try {
          return originalInsertRule.call(this, rule, index)
        } catch (error) {
          const message = error?.message || String(error)
          if (
            message.includes("Failed to parse the rule") ||
            message.includes("insertRule") ||
            message.includes("@font-face")
          ) {
            return -1
          }
          throw error
        }
      }
      Object.defineProperty(CSSStyleSheet.prototype.insertRule, "__healmePatched", { value: true })
    }
  }
}
